import React from 'react'
import { Link } from 'react-router-dom'
import './Legal.css'

export default function Privacy() {
  return (
    <div className="legal-page page-fade">
      <div className="container">
        <div className="legal-header">
          <Link to="/" className="btn btn-ghost btn-sm" style={{ marginBottom: 24 }}>← Home</Link>
          <h1>Privacy Policy</h1>
          <p className="legal-meta">Last updated: May 2026</p>
        </div>
        <div className="legal-body">
          <section>
            <h2>1. Who we are</h2>
            <p>HumanOrigin ("we", "us", "our") is a creative verification platform available at <strong>humanorigin.app</strong>. We help creators prove their work is human-made through a human review process.</p>
          </section>
          <section>
            <h2>2. What information we collect</h2>
            <p>We collect the following information when you use HumanOrigin:</p>
            <ul>
              <li><strong>Account information</strong> — your name, email address, and username when you sign up via email or Google OAuth.</li>
              <li><strong>Profile information</strong> — display name, bio, and website URL that you optionally provide.</li>
              <li><strong>Project and commit data</strong> — titles, descriptions, categories, commit messages, photos, and links you upload as part of your creative projects.</li>
              <li><strong>Review activity</strong> — verdicts and flags you submit as a reviewer, and reviews and flags submitted on your own work.</li>
              <li><strong>Usage data</strong> — basic analytics such as pages visited, collected by Netlify.</li>
            </ul>
          </section>
          <section>
            <h2>3. How we use your information</h2>
            <ul>
              <li>To provide and operate the HumanOrigin platform</li>
              <li>To display your public profile and verified works to other users</li>
              <li>To review your project submissions and issue certificates</li>
              <li>To send you notifications about your submissions</li>
            </ul>
          </section>
          <section>
            <h2>4. What we share</h2>
            <p>We do not sell your personal data. We share data only with:</p>
            <ul>
              <li><strong>Supabase</strong> — our database and authentication provider</li>
              <li><strong>Netlify</strong> — our hosting provider</li>
              <li><strong>Google</strong> — if you choose to sign in with Google</li>
            </ul>
          </section>
          <section>
            <h2>5. Public content</h2>
            <p>Projects you set to <strong>Public</strong> visibility are visible to anyone on the internet including your profile, commit history, and certificate. Projects set to <strong>Unlisted</strong> are accessible only by direct link. Projects set to <strong>Private</strong> are visible only to you.</p>
          </section>
          <section>
            <h2>6. Data retention</h2>
            <p>We retain your data for as long as your account exists. You may request deletion of your account and associated data by contacting us. Verified certificates may be retained in anonymised form for the integrity of the verification record.</p>
          </section>
          <section>
            <h2>7. Your rights</h2>
            <p>You have the right to access, correct, or delete your personal data. To exercise these rights, contact us at the email below.</p>
          </section>
          <section>
            <h2>8. Cookies</h2>
            <p>We use essential cookies for authentication managed by Supabase. We do not use advertising or tracking cookies.</p>
          </section>
          <section>
            <h2>9. Changes to this policy</h2>
            <p>We may update this policy from time to time. We will notify you of significant changes by posting a notice on the site.</p>
          </section>
          <section>
            <h2>10. Contact</h2>
            <p>For any privacy-related questions, contact us at <strong>humanorigin.app@gmail.com</strong></p>
          </section>
        </div>
      </div>
    </div>
  )
}
